import { useEffect, useState, type FormEvent } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeft, Save } from 'lucide-react';
import { useAlbum, useUpdateAlbum } from '../../lib/queries';

export default function EditAlbum() {
  const { albumId } = useParams<{ albumId: string }>();
  const navigate = useNavigate();
  const { data, isLoading } = useAlbum(albumId);
  const update = useUpdateAlbum(albumId ?? '');

  const [name, setName] = useState('');
  const [description, setDescription] = useState('');

  useEffect(() => {
    if (data?.album) {
      setName(data.album.name);
      setDescription(data.album.description ?? '');
    }
  }, [data]);

  if (isLoading) return <p className="text-ink-muted">Laddar…</p>;
  if (!data) return <p className="text-ink-muted">Album hittades inte.</p>;

  function handleSave(e: FormEvent) {
    e.preventDefault();
    void (async () => {
      try {
        await update.mutateAsync({
          name: name.trim(),
          description: description.trim() || null,
        });
        await navigate('/admin/album');
      } catch {
        // mutation error visas via update.error i UI vid behov
      }
    })();
  }

  return (
    <div className="max-w-2xl mx-auto">
      <button
        type="button"
        onClick={() => navigate('/admin/album')}
        className="flex items-center gap-2 text-ink-muted mb-4"
      >
        <ArrowLeft size={16} /> Tillbaka
      </button>

      <h1 className="text-3xl font-serif text-primary mb-6">Redigera album</h1>

      <form onSubmit={handleSave} className="bg-white rounded-2xl p-6 shadow-sm space-y-4">
        <label className="block">
          <span className="block text-sm font-medium mb-1">Namn</span>
          <input
            type="text"
            required
            value={name}
            onChange={(e) => { setName(e.target.value); }}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:border-primary focus:outline-none"
          />
        </label>
        <label className="block">
          <span className="block text-sm font-medium mb-1">Beskrivning</span>
          <textarea
            value={description}
            onChange={(e) => { setDescription(e.target.value); }}
            rows={3}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:border-primary focus:outline-none"
          />
        </label>
        <button
          type="submit"
          disabled={update.isPending}
          className="bg-primary hover:bg-primary-hover text-white px-6 py-2 rounded-lg flex items-center gap-2 disabled:opacity-50"
        >
          <Save size={18} /> Spara
        </button>
      </form>
    </div>
  );
}
